import { Card, type CardProps } from "@mui/material"

export function Root({ sx, children, ...rest }: CardProps) {
  return (
    <Card
      sx={{
        position: "relative",
        padding: 4,
        display: "flex",
        minHeight: "100%",
        flex: 1,
        flexDirection: "column",
        borderRadius: 3,
        gap: 2,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Card>
  )
}
